"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenTree = exports.removeAllVals = exports.removeVal = exports.containsAllVals = exports.containsVal = void 0;

var containsVal = function containsVal(arr, val) {
  var result = false;

  for (var i = 0; i < arr.length; i++) {
    if ((arr[i].id ? arr[i].id : arr[i]) === val) {
      result = true;
    }
  }

  return result;
};

exports.containsVal = containsVal;

var containsAllVals = function containsAllVals(arr, vals) {
  var result = true;

  for (var i = 0; i < vals.length; i++) {
    if (!containsVal(arr, vals[i].id ? vals[i].id : vals[i])) {
      result = false;
    }
  }

  return result;
};

exports.containsAllVals = containsAllVals;

var removeVal = function removeVal(arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if ((arr[i].id ? arr[i].id : arr[i]) === val) {
      arr.splice(i, 1);
    }
  }

  return arr;
};

exports.removeVal = removeVal;

var removeAllVals = function removeAllVals(arr, vals) {
  for (var i = 0; i < vals.length; i++) {
    removeVal(arr, vals[i].id ? vals[i].id : vals[i]);
  }

  return arr;
};

exports.removeAllVals = removeAllVals;

var flattenTree = function flattenTree(nodes) {
  var children = [];
  nodes.forEach(addChildren);

  function addChildren(node) {
    children.push(node);
    if (node.children) node.children.forEach(addChildren);
  }

  return children;
};

exports.flattenTree = flattenTree;